module.exports = __webpack_public_path__ + "img/RobertBoyle.08a723cc.jpg";